import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

const NotFound = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100%',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e4ecfb 100%)',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          maxWidth: '800px',
          textAlign: 'center',
          zIndex: 2,
          px: 3,
        }}
      >
        <Typography 
          variant="h1" 
          color="primary" 
          sx={{ 
            fontSize: { xs: '8rem', md: '15rem' }, 
            fontWeight: 800,
            mb: 2,
            background: 'linear-gradient(90deg, #3a8ef6 0%, #6f42c1 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textShadow: '0 10px 30px rgba(0,0,0,0.1)',
          }}
        >
          404
        </Typography>
        
        <Typography 
          variant="h4" 
          sx={{ 
            mb: 4, 
            fontWeight: 600,
            color: '#2D3748',
            fontSize: { xs: '1.5rem', md: '2.5rem' },
          }}
        >
          Page Not Found
        </Typography>
        
        <Typography 
          variant="body1" 
          sx={{ 
            mb: 6, 
            maxWidth: '600px',
            color: '#4A5568',
            fontSize: { xs: '1rem', md: '1.2rem' },
          }}
        >
          The page you're looking for doesn't exist or has been moved. 
          Please check the URL or navigate back to the dashboard.
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Button 
            component={Link} 
            to="/"
            variant="contained" 
            color="primary"
            size="large"
            sx={{ 
              px: 4, 
              py: 1.5,
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 500,
              background: 'linear-gradient(90deg, #3a8ef6 0%, #6f42c1 100%)',
              '&:hover': {
                background: 'linear-gradient(90deg, #2c7be5 0%, #6610f2 100%)',
              },
              boxShadow: '0 4px 14px 0 rgba(16, 101, 240, 0.39)'
            }}
          >
            Return to Dashboard
          </Button>
          
          <Button 
            component={Link} 
            to="/appointments"
            variant="outlined" 
            size="large"
            sx={{ 
              px: 4, 
              py: 1.5,
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 500,
              borderColor: '#3a8ef6',
              color: '#3a8ef6',
              '&:hover': {
                borderColor: '#2c7be5',
                background: 'rgba(16, 101, 240, 0.04)'
              }
            }}
          >
            View Appointments
          </Button>
        </Box>
      </Box>
      
      {/* Decorative elements */}
      <Box 
        sx={{ 
          position: 'absolute', 
          width: '600px', 
          height: '600px', 
          borderRadius: '50%', 
          background: 'radial-gradient(circle, rgba(124, 196, 255, 0.2) 0%, rgba(16, 101, 240, 0.1) 70%, transparent 100%)',
          top: '-200px',
          right: '-100px',
          zIndex: 1
        }} 
      />
      
      <Box 
        sx={{ 
          position: 'absolute', 
          width: '500px', 
          height: '500px', 
          borderRadius: '50%', 
          background: 'radial-gradient(circle, rgba(124, 196, 255, 0.2) 0%, rgba(16, 101, 240, 0.1) 70%, transparent 100%)',
          bottom: '-150px',
          left: '-150px',
          zIndex: 1
        }} 
      />
      
      <Box 
        sx={{ 
          position: 'absolute', 
          width: '300px', 
          height: '300px', 
          borderRadius: '50%', 
          background: 'radial-gradient(circle, rgba(111, 66, 193, 0.15) 0%, rgba(111, 66, 193, 0.05) 70%, transparent 100%)',
          top: '20%',
          left: '15%',
          zIndex: 1
        }} 
      />
      
      <Box 
        sx={{ 
          position: 'absolute', 
          width: '250px', 
          height: '250px', 
          borderRadius: '50%', 
          background: 'radial-gradient(circle, rgba(111, 66, 193, 0.15) 0%, rgba(111, 66, 193, 0.05) 70%, transparent 100%)',
          bottom: '15%',
          right: '10%',
          zIndex: 1
        }} 
      />
    </Box>
  );
};

export default NotFound;
